<template>
    <v-navigation-drawer :value="isMenu" @input="closeMenuhandler($event)" class="mobile-menu" absolute temporary>

        <router-link to="/" class="logo">
            <span>Logo</span>
        </router-link>

        <v-list dense>
            <v-list-item>
                <router-link to="/" class="menu-item">
                    <div class="icon-wrapp">
                        <v-icon>fa-home</v-icon>
                    </div>
                    <span>Hjem</span>
                </router-link>
            </v-list-item>

            <v-list-item>
                <router-link to="/faktura" class="menu-item">
                    <div class="icon-wrapp">
                        <v-icon>fa-file</v-icon>
                    </div>
                    <span>Faktura</span>
                </router-link>
            </v-list-item>

            <v-list-item>
                <router-link to="/legg-til" class="menu-item">
                    <div class="icon-wrapp">
                        <v-icon>fa-plus</v-icon>
                    </div>
                    <span>Legg til</span>
                </router-link>
            </v-list-item>

            <v-list-item>
                <router-link to="/bruker" class="menu-item">
                    <div class="icon-wrapp">
                        <v-icon>fa-user</v-icon>
                    </div>
                    <span>Bruker</span>
                </router-link>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import './Header/Header.scss';

export default {
    name: 'NavBar',

    components: {},

    data(){
        return{
            drawer: true
        }
    },

    computed: {
        ...mapGetters(['isMenu'])
    },

    methods: {
        ...mapMutations(['closeMenu']),

        closeMenuhandler(e){

            if(!e){
                this.closeMenu();
            }
        }
    }
}
</script>
